import { render, staticRenderFns } from "./ShareHeader.vue?vue&type=template&id=2129afb3"
import script from "./ShareHeader.vue?vue&type=script&lang=js"
export * from "./ShareHeader.vue?vue&type=script&lang=js"
import style0 from "./ShareHeader.vue?vue&type=style&index=0&lang=postcss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports